import React, { useState } from 'react';
import { FaXmark } from 'react-icons/fa6';

export default function ModalTrocaSituacao({ submit, close, procedente }) {
  const [res, setRes] = useState({
    procedencia: procedente === undefined ? false : procedente,
    gravidade: 'BAIXA',
    status: 'EM_ANDAMENTO',
    alteradoPor: 'Equipe Mig-PLUS',
  })
  console.log(res)

  const handleChange = (e) => setRes({ ...res, [e.target.name]: e.target.value })

  return (
    <div className='fixed w-full h-full flex items-center justify-center bg-secondary top-0 bg-opacity-60 '>
      <div className='bg-white w-2/3 max-h-[80%] rounded p-8 overflow-y-auto'>
        <div className='flex gap-3 flex-col'>
          <div className='flex justify-between items-center text-primary text-xl'>
            <h1 className='font-semibold'>Trocar Situação</h1>
            <span className='hover:cursor-pointer' onClick={() => close(false)}><FaXmark /></span>
          </div>
          <div className='flex gap-3'>
            <span className='font-semibold text-primary'>Classificação:</span>
            <label >Procedente 
              <input type="checkbox" value={res.procedencia} checked={res.procedencia === true} name="procedencia" id="procedencia" className='rounded border-2 border-secondary px-2 py-1 outline-primary' onChange={() => setRes({...res, procedencia : !res.procedencia})} />
            </label>
          </div>
          <div className='flex flex-col gap-2'>
            <span className='font-semibold text-primary'>Status:</span>
            <select name="status" id="status" className='border-2 border-secondary rounded px-2 py-1 outline-primary text-primary' onChange={(e) => handleChange(e)}>
              <option value={'EM_ANDAMENTO'}>Em Andamento</option>
              <option value={'CONCLUIDO'}>Concluído</option>
              <option value={'AGUARDANDO_RESPOSTA'}>Aguardando resposta</option>
            </select>
          </div>
          <div>
            <span className='font-semibold text-primary'>Grau de Violação:</span>
            <div className='flex gap-2'>
              <input type="radio" name="gravidade" id="BAIXA" value={'BAIXA'} defaultChecked className='rounded border-2 border-secondary px-2 py-1 outline-primary' onChange={(e) => handleChange(e)} />
              <label htmlFor="BAIXA">Leve</label>
              <input type="radio" name="gravidade" id="MEDIA" value={'MEDIA'} className='rounded border-2 border-secondary px-2 py-1 outline-primary' onChange={(e) => handleChange(e)} />
              <label htmlFor="MEDIA">Moderada</label> 
              <input type="radio" name="gravidade" id="ALTA" value={'ALTA'} className='rounded border-2 border-secondary px-2 py-1 outline-primary' onChange={(e) => handleChange(e)} />
              <label htmlFor="ALTA">Grave</label>
            </div>
          </div>
          <div className='flex justify-end'>
            <button className='bg-primary text-white px-4 py-2 rounded' onClick={() => submit(res)}>Enviar</button>
          </div>
        </div>
      </div>
    </div>
  )
};
